import React from 'react';
import './WhatsAppIcon.css'; 
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppIcon = () => {
  return (
    <div>
      <a
        href="https://wa.me/+917019444941"  
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-icon"
      >
        <FaWhatsapp size={40} color="white" />
      </a>
      <div className="message-text">
        Message Us
      </div>
    </div>
  );
};

export default WhatsAppIcon;
